module.exports = __webpack_public_path__ + "img/tests.c9234323.svg";